import { render, staticRenderFns } from "./DetailComp.vue?vue&type=template&id=4232d332&scoped=true"
import script from "./DetailComp.vue?vue&type=script&lang=js"
export * from "./DetailComp.vue?vue&type=script&lang=js"
import style0 from "./DetailComp.vue?vue&type=style&index=0&id=4232d332&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4232d332",
  null
  
)

export default component.exports